<template>
  <div class="list-header p-a-md-3 ai-md-c">
    <div class="only-mobile filter d-f">
      <Button icon="trash-24" :class="`ml-md-a small no-border-radius keep-hover blue f-1 no-padding only-icon`" @click=""></Button>
    </div>
    <div class="only-desktop f-1">
      <Button icon="trash-24" class="ml-md-a medium minimal-border-radius only-text keep-hover red with-extra-side-padding">Filter</Button>
    </div>
    <div class="search ml-md-a mr-md-a f-md-1-5">
      <form-input-text class="f-w" icon="search-magnify-24" id="search" placeholder="Search customers"></form-input-text>
    </div>
    <div class="only-mobile buttons f-w d-f">
      <div class="button">
        <Button class="f-w medium only-text keep-hover blue padding">Select all</Button>
      </div>
      <div class="button">
        <Button class="f-w medium only-text keep-hover blue padding">Sort</Button>
      </div>
      <div class="button">
        <Button icon="trash-24" class="f-w small only-text only-icon keep-hover red padding"></Button>
      </div>
      <div class="button">
        <Button icon="accounting-24" class="f-w small only-text only-icon keep-hover blue padding"></Button>
      </div>
    </div>
    <div class="only-desktop d-f f-1">
      <div class="button ml-a">
        <Button icon="trash-24" class="ml-md-a medium only-text keep-hover red with-extra-side-padding">Delete</Button>
      </div>
      <div class="button">
        <Button icon="accounting-24" class="medium only-text keep-hover blue with-extra-side-padding">Export</Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.list-header {
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 767px) {
    .filter {
      border-bottom: 1px solid #d8dae1;
      width: 60px;
    }

    .search {
      width: calc(100% - 60px);

      .input {
        border-radius: 0;
        border-top: 0;
        border-right: 0;
      }
    }

    .buttons {
      & > * {
        border-bottom: 1px solid #d8dae1;
        flex: 1;

        &:not(:last-child) {
          border-right: 1px solid #d8dae1;
        }
      }
    }
  }
}
</style>
